import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { DataService } from '../../data.service';

/**
 *  NAPI HIÁNYZÓK AZ EBÉDRENDELŐK KÖZÜL  (#1070, Európa 2000)
 *
 *  Aki ebédeltet, annak azt kell látnia, hogy az aznapra ebédet rendelt gyerekek közül ki
 *  hiányzik – és főleg, hogy REGGEL ÓTA hiányzik-e, mert akkor az ebédje kiadható másnak.
 *  Eddig ehhez osztályonként kellett a naplót végignézni; itt egy dátumra, az egész
 *  intézményre áll össze (GET /etkezes-rendeles/napi-hianyzok/:datum/:intezmeny).
 *
 *  A hiányzás csak a KÖNYVELT órákról ismert. A még be nem írt órák számát ezért mindig
 *  kiírjuk: délelőtt a lista szükségképpen hiányos, és ezt nem szabad elhallgatni.
 *
 *  Két helyen jelenik meg: az Étkezés képernyőn (dolgozói nézet, gombbal nyíló ablakban)
 *  és az admin Étkezés-beállításoknál kártyaként.
 */
@Component({
  selector: 'app-etkezes-napi-hianyzok',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './etkezes-napi-hianyzok.component.html',
  styleUrls: ['./etkezes-napi-hianyzok.component.scss'],
})
export class EtkezesNapiHianyzokComponent implements OnInit, OnChanges {
  /** Az intézmény azonosítója (sajatIntezmeny.intezmenyId). */
  @Input() intezmeny: string = '';

  /*  A mai nap HELYI idő szerint: a toISOString UTC-ben számol, és éjfél után két órán
   *  át a tegnapot adná. */
  nap = EtkezesNapiHianyzokComponent.maiNap();
  /** rendelt = aznapra ebédet rendelt · etkezo = rendelt vagy étkezési belépése van · mind */
  kor: 'rendelt' | 'etkezo' | 'mind' = 'rendelt';
  csakReggelOta = false;

  adat: any = null;
  fut = false;
  hiba = '';

  constructor(private http: HttpClient, private data: DataService) {}

  static maiNap(): string {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  ngOnInit() { this.betolt(); }

  ngOnChanges(v: SimpleChanges) {
    if (v['intezmeny'] && !v['intezmeny'].firstChange) this.betolt();
  }

  betolt() {
    if (!this.intezmeny || !this.nap) return;
    this.fut = true;
    this.hiba = '';
    this.http.get<any>(`/api/etkezes-rendeles/napi-hianyzok/${String(this.nap).slice(0, 10)}/${this.intezmeny}`)
      .subscribe({
        next: (r) => { this.adat = r; this.fut = false; },
        error: (e) => {
          this.fut = false;
          this.adat = null;
          this.hiba = e?.error?.error || 'A napi hiányzók nem tölthetők be.';
          this.data.sendToast(this.hiba, 'error');
        },
      });
  }

  get sorok(): any[] {
    let s: any[] = this.adat?.tetelek || [];
    if (this.kor === 'rendelt') s = s.filter((t) => t.ebed);
    else if (this.kor === 'etkezo') s = s.filter((t) => t.ebed || t.belepett);
    if (this.csakReggelOta) s = s.filter((t) => t.reggel_ota);
    return s;
  }

  oraCim(o: any): string {
    const allapot = !o.konyvelt ? 'még nincs beírva' : o.hianyzott ? 'hiányzott' : 'jelen volt';
    return `${o.ora}. óra${o.tantargy ? ' – ' + o.tantargy : ''}: ${allapot}`;
  }
}
